var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { Text, Tooltip } from "../../../../Atoms";
var MultiTextTooltipCell = function (_a) {
    var displayValues = _a.displayValues, textProps = _a.textProps;
    var firstValue = displayValues[0];
    var hasWhiteTooltip = displayValues.length > 1;
    if (displayValues.length === 0) {
        return (_jsx(Stack, __assign({ direction: "row" }, { children: _jsx(Text, __assign({ sx: {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                } }, textProps, { children: "-" })) })));
    }
    var Cell = (_jsxs(Stack, __assign({ direction: "row" }, { children: [_jsx(Text, __assign({ sx: {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                } }, textProps, { children: firstValue.displayText })), hasWhiteTooltip ? (_jsxs(Text, __assign({ variant: "body2", whiteSpace: "nowrap" }, { children: ["\u00A0+", displayValues.length - 1] }))) : firstValue.link ? (_jsxs(_Fragment, { children: ["\u00A0", _jsx(LinkIcon, { fontSize: "small" })] })) : null] })));
    if (hasWhiteTooltip) {
        return (_jsx(Tooltip, __assign({ title: "", tooltipColor: "white", links: displayValues }, { children: Cell })));
    }
    if (firstValue.link) {
        return _jsx(Tooltip, __assign({ title: firstValue.link }, { children: Cell }));
    }
    return Cell;
};
export default MultiTextTooltipCell;
